import { useCallback, useEffect, useRef, useState } from 'react';

import { GetFlightDealsData, getFlightDeals } from '~/services/FlightsService';

import { FLIGHT_DEALS_LIST_ATTRIBUTES } from '../constants';

const PAGE_SIZE = 20;

const initialOptions = {
  page: 0,
  pageSize: PAGE_SIZE,
  attributes: FLIGHT_DEALS_LIST_ATTRIBUTES,
};

export function useFlightDeals(options: GetFlightDealsData = initialOptions, enabled = true) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [data, setData] = useState<{ rows: Array<App.FlightDeal>; count: number }>({ rows: [], count: 0 });
  const latestRequestId = useRef(0);

  const fetchDealsData = useCallback(async () => {
    const requestId = ++latestRequestId.current;
    setLoading(true);
    setError(undefined);

    try {
      const { result } = await getFlightDeals(options);
      if (requestId === latestRequestId.current) {
        setData({ count: result.count, rows: result.rows });
      }
    } catch (error) {
      if (requestId === latestRequestId.current) {
        setError(error);
      }
    }

    if (requestId === latestRequestId.current) {
      setLoading(false);
    }
  }, [options]);

  useEffect(() => {
    if (!enabled) {
      latestRequestId.current += 1;
      setLoading(false);
      setError(undefined);
      return;
    }

    fetchDealsData();
  }, [enabled, fetchDealsData]);

  return { loading, error, data, revalidate: fetchDealsData };
}
